import React, { useEffect } from "react"
import styled from "styled-components"
import { Layout } from "../components"
import RubyVyvojarKaJobDetail from "./ruby-vyvojar-ka-job-detail"

import VideoPoster from "../images/video-poster.jpg"
import Tucnak from "../images/tucnak/tucnak.svg"
import OgImage from "../images/position/og-image-linux-admin.jpg"
import { Helmet } from "react-helmet"

const Banner = styled.div`
  position: relative;
  padding: 30px 0;
  max-height: calc(100vh - 59px);
  background: ${(props) => props.theme.color.primary};
  overflow: hidden;

  &:before {
    @media (min-width: ${(props) => props.theme.sizes_min.xxl}) {
      content: "";
      background: url(${Tucnak}) no-repeat 0 0;
      background-size: contain;
      width: 250px;
      height: 407px;
      display: block;
      position: absolute;
      bottom: -150px;
      right: 50px;
    }
  }

  @media (min-width: ${(props) => props.theme.sizes_min.md}) {
    padding: 0;
  }
`

const BannerVideoWrapper = styled.div`
  display: none;

  @media (min-width: ${(props) => props.theme.sizes_min.md}) {
    display: block;
  }
`

export default function LinuxAdmin() {
  useEffect(() => {
    document.body.classList.add("modal-open")

    return function cleanup() {
      document.body.classList.remove("modal-open")
    }
  }, [])
  return (
    <Layout>
      <Helmet>
        <title>Pojď nám prosím spravit Redmine! | igloonet</title>
        <meta
          name="description"
          content="Hledáme externího či part-time parťáka, který by nám pomohl s údržbou a rozvojem Redmine a dalších interních systémů v Ruby (on Rails)."
        />
        <meta property="og:title" content="Pojď nám prosím spravit Redmine!" />
        <meta property="og:image" content={OgImage} />
      </Helmet>
      <RubyVyvojarKaJobDetail />

      <Banner>
        <BannerVideoWrapper>
          <img
            className="lazy"
            src={VideoPoster}
            alt="text"
            width="1920"
            height="1080"
          />
        </BannerVideoWrapper>
      </Banner>
    </Layout>
  )
}
